module.exports = __webpack_public_path__ + "img/icon-cancel.89673497.png";